// Quote line maths — mirrors backend _compute_line (unit_price_inr = canonical EXCLUSIVE unit price, full precision).
export const r2 = (x) => {
  const n = Math.abs(Number(x) || 0);
  const six = Math.round(n * 1e6) / 1e6; // drop binary-float noise first (matches backend)
  return Math.sign(Number(x) || 0) * Math.round(six * 100 + 1e-7) / 100;
};
export const rateOf = (it) => (it?.tax_pct === "" || it?.tax_pct == null ? 18 : Number(it.tax_pct) || 0);
export const inclToBase = (incl, rate) => (Number(incl) || 0) / (1 + (Number(rate) || 0) / 100);
export const baseToIncl = (base, rate) => (Number(base) || 0) * (1 + (Number(rate) || 0) / 100);

export function lineCalc(it) {
  const qty = Number(it?.quantity) || 0;
  const unit = Number(it?.unit_price_inr) || 0;
  const disc = Number(it?.discount_pct) || 0;
  const rate = rateOf(it);
  const afterDisc = qty * unit * (1 - disc / 100);
  const sub = r2(afterDisc);
  const total = r2(afterDisc * (1 + rate / 100));
  return { rate, qty, disc, unitBase: unit, unitGst: unit * rate / 100, unitIncl: baseToIncl(unit, rate), sub, tax: r2(total - sub), total };
}

// Payload line: strip UI-only keys (_price_mode, _incl_draft), keep 0% GST (no blanket 18).
export function cleanItem(it) {
  const out = {};
  Object.keys(it).forEach((k) => { if (!k.startsWith("_")) out[k] = it[k]; });
  return { ...out,
    quantity: Number(it.quantity),
    unit_price_inr: Number(it.unit_price_inr) || 0,
    vendor_unit_cost_inr: Number(it.vendor_unit_cost_inr || 0),
    tax_pct: rateOf(it),
    discount_pct: Number(it.discount_pct || 0) };
}
